/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { CieloMerchant } from '../../../core/_models'

type Props = {
    cieloMerchant: CieloMerchant
}

const ExpirationCell: FC<Props> = ({ cieloMerchant }) => (
    <div className='d-flex flex-column'>
        <span className='text-gray-800 mb-1'>{cieloMerchant.expirationAt || 'N/A'}</span>
    </div>
)

export { ExpirationCell }
